export default __webpack_public_path__ + "static/media/content5-transparent.8426bc74.png";